import { ModalsManager } from '@/components/modals/modalsManager';
import { MCPAddServerModal } from '@/features/mcp/MCPAddServerModal';
import { RegionSelectModal } from '@/integrations/custom/region-select-modal';

import { ZOHO_MCP_REGION_OPTIONS } from './regions';

import type { GuidedCustomMcpOffer } from '../guided-custom-mcp';
import type { CachedMCPServer } from '@littlebird/mcp';

const ZOHO_CRM_MCP_DISPLAY_NAME = 'Zoho CRM';

async function connectZohoCrmViaCustomMcp(): Promise<void> {
  const mcpUrl = await ModalsManager.showResolvable(RegionSelectModal, {
    title: 'Zoho CRM region',
    description: 'Choose where your Zoho account is hosted.',
    options: ZOHO_MCP_REGION_OPTIONS,
  });
  if (!mcpUrl) return;

  ModalsManager.show(MCPAddServerModal, {
    initialName: ZOHO_CRM_MCP_DISPLAY_NAME,
    initialUrl: mcpUrl,
  });
}

function looksLikeZohoMcpServer(server: CachedMCPServer): boolean {
  return /zohomcp\./i.test(server.url);
}

export const zohoCrmOffer: GuidedCustomMcpOffer = {
  id: 'zoho_crm',
  name: ZOHO_CRM_MCP_DISPLAY_NAME,
  description: 'Connect Zoho CRM via MCP to search and act on CRM records.',
  icon: 'zoho',
  categories: ['sales_marketing'],
  searchText: 'zoho crm mcp zohomcp',
  isConnected: (servers) => servers.some(looksLikeZohoMcpServer),
  connect: connectZohoCrmViaCustomMcp,
};
